const kz = {
  // Common & UI
  'app.name': 'ЭНЗП',
  'common.loading': 'Жүктелуде...',
  'common.save': 'Сақтау',
  'common.cancel': 'Бас тарту',
  'common.delete': 'Жою',
  'common.edit': 'Өңдеу',
  'common.add': 'Қосу',
  'common.create': 'Құру',
  'common.close': 'Жабу',
  'common.back': 'Артқа',
  'common.search': 'Іздеу',
  'common.clear': 'Тазарту',
  'common.confirm': 'Растау',
  'common.view': 'Қарау',
  'common.download': 'Жүктеп алу',
  'common.upload': 'Жүктеу',
  'common.sign': 'Қол қою',
  'common.actions': 'Әрекеттер',
  'common.status': 'Мәртебесі',
  'common.date': 'Күні',
  'common.time': 'Уақыты',
  'common.id': 'ID',
  'common.number': 'Нөмірі',
  'common.name': 'Атауы',
  'common.description': 'Сипаттамасы',
  'common.author': 'Авторы',
  'common.branch': 'Филиал',
  'common.yes': 'Иә',
  'common.no': 'Жоқ',
  'common.all': 'Барлығы',
  'common.filter': 'Сүзгі',
  'common.reset': 'Қалпына келтіру',
  'common.required_field': 'Өрісті толтырыңыз',
  'common.enter_name': 'Атауын енгізіңіз',
  'common.proceed': 'ӨТУ',
  'common.photo': 'СУРЕТ',
  'common.post': 'Жариялау',
  'common.comment': 'Пікір қалдыру',
  'common.write_comment': 'Пікір жазу...',
  'common.attach_files': 'Файл(дарды) тіркеу',
  'common.notifications': 'Хабарламалар',
  'common.success': 'Сәтті',
  'common.error': 'Қате',
  'common.warning': 'Ескерту',
  'common.info': 'Ақпарат',
  'common.empty': 'Деректер жоқ',
  'common.fio': 'Аты-жөні',
  'common.position': 'Лауазымы',
  'common.phone': 'Телефон',
  'common.email': 'Email',
  'common.start': 'Басталуы',
  'common.end': 'Аяқталуы',
  'common.details': 'Толығырақ',
  'filter.process': 'Процесс',
  'filter.object': 'Нысан',
  'filter.work_type': 'Жұмыс түрі',

  // Navigation
  'nav.main': 'Басты бет',
  'nav.create_task': 'Наряд-тапсырма құру',
  'nav.create_task_old': 'Наряд құру (ескі)',
  'nav.electro_journal': 'Наряд-рұқсат (электр)',
  'nav.non_electro_journal': 'Наряд-рұқсат (электр емес)',
  'nav.operation': 'Өкім',
  'nav.current_operation': 'Ағымдағы пайдалану тәртібіндегі жұмыс',
  'nav.ppr': 'ЖЖЖ кестесі',
  'nav.weather_journal': 'Ауа райы журналы',
  'nav.smax_journal': 'СМАКС журналы',
  'nav.users': 'Пайдаланушылар',
  'nav.instructions': 'Нұсқаулықтар',
  'nav.references': 'Анықтамалық',
  'nav.processes': 'Процесс түрлері',
  'nav.reports': 'Есептер',
  'nav.download_playmarket': 'PlayMarket-тен жүктеу',
  'nav.download_appstore': 'AppStore-дан жүктеу',

  // Reports
  'report.title': 'Есептер және статистиканы жүктеу',
  'report.user_activity_stat': 'Пайдаланушылар белсенділігінің статистикасы',
  'report.works_journal': 'Жұмыстарды есепке алу журналы',
  'report.general_dynamics': 'Жалпы динамика',
  'report.filials_dynamics': 'Филиалдар бойынша динамика',
  'report.work_types_stat': 'Жұмыс түрлері бойынша статистика',
  'report.filials_tasktypes_stat': 'Жұмыс түрлері бойынша филиалдар статистикасы',
  'report.visiting_works_report': 'Шығу жұмыстары бойынша есеп',
  'report.smax_summary_report': 'SMAX бойынша жиынтық есеп',
  'report.med_inspection_info': 'Медициналық тексеру туралы ақпарат',
  'report.select_year': 'Жылды таңдаңыз',
  'report.select_branch': 'Филиалды таңдаңыз',
  'report.select_date': 'Күнді таңдаңыз!',
  'report.select_year_error': 'Жылды таңдаңыз!',
  'report.select_branch_error': 'Филиалды таңдаңыз!',
  'report.download_success': 'Есеп сәтті жүктелді!',
  'report.download_error': 'Есепті жүктеу сәтсіз аяқталды!',

  // Header
  'header.edit_photo': 'Суретті өзгерту',
  'header.logout': 'Жүйеден шығу',
  'header.admin': 'Жүйе әкімшісі',
  'header.photo_updated': 'Пайдаланушы сәтті өзгертілді!',
  'header.photo_format_warning': 'Файл JPEG/PNG пішімінде болуы керек!',
  'header.choose_photo': 'Суретті таңдаңыз',

  // Breadcrumbs / Work Types
  'breadcrumb.home': 'Басты бет',
  'breadcrumb.processes': 'Процестер',
  'breadcrumb.objects': 'Процесс нысандары',
  'breadcrumb.technologies': 'Технология түрлері',
  'breadcrumb.zones': 'Қызмет көрсету аймағы',
  'breadcrumb.conditions': 'Шарттар',
  'breadcrumb.task_types': 'Жұмыс түрлері',
  'breadcrumb.operations': 'Операциялар тізімі',
  'breadcrumb.edit_task_group': 'ЖҰМЫС ТОБЫН ӨҢДЕУ',

  // Task Creation
  'create_task.title': 'Наряд-тапсырма құру',
  'create_task.task_type': 'Тапсырма түрі',
  'create_task.task_type_placeholder': 'Тапсырма түрін таңдаңыз',
  'create_task.process': 'Процесс',
  'create_task.process_placeholder': 'Процесті таңдаңыз',
  'create_task.object': 'Нысан',
  'create_task.object_placeholder': 'Нысанды таңдаңыз',
  'create_task.zone': 'Қызмет көрсету аймағы',
  'create_task.zone_placeholder': 'Қызмет көрсету аймағын таңдаңыз',
  'create_task.condition': 'Өндіріс шарттары',
  'create_task.condition_placeholder': 'Өндіріс шарттарын таңдаңыз',
  'create_task.work_type': 'Жұмыс түрі',
  'create_task.work_type_placeholder': 'Жұмыс түрін таңдаңыз',
  'create_task.other_work_type': 'ҚЫЗМЕТКЕР ҰСЫНҒАН ЖҰМЫС ТҮРІ',
  'create_task.access_denied': 'Қолжетімділік шектелген',
  'create_task.access_denied_reason': 'Наряд құруға тыйым салынған. Себебі: 1С мәліметтері бойынша сіздің мәртебеңіз: ',

  // Statuses
  'status.created': 'Құрылды',
  'status.issued': 'Берілді',
  'status.received_for_work': 'Жұмысқа қабылданды',
  'status.on_route': 'Жолда',
  'status.suspended': 'Тоқтатылды',
  'status.completed_without_eds': 'ЭЦҚ растауынсыз аяқталды',
  'status.in_progress': 'Жұмыста',
  'status.rejected': 'Қабылданбады',
  'status.finished': 'Аяқталды',
  'status.draft': 'Жоба',
  'status.on_approval': 'Келісуде',
  'status.on_signature': 'Қол қойылуда',
  'status.signed': 'Қол қойылды',
  'status.active': 'Қолданыста',
  'status.closed': 'Жабылды',
  'status.sick': 'Ауырып жатыр',
  'status.vacation': 'Жыл сайынғы еңбек демалысында',
  'status.business_trip': 'Іссапарда',
  'status.dismissed': 'Жұмыстан босатылған',
  'status.working': 'Жұмыс істейді',
  'status.finished_from_smax': 'SMAX-та аяқталды',
  'status.transfer': 'Қайта тағайындалды',

  // Tables & Journals
  'table.created': 'ҚҰРЫЛДЫ',
  'table.place_and_name': 'Жұмыс орны мен атауы',
  'table.specified_time': 'Көрсетілген жұмыс уақыты',
  'table.start_date': 'Басталу күні',
  'table.end_date': 'Аяқталу күні',
  'table.started_at': 'Жұмысқа кірісті (күні, уақыты)',
  'table.finished_at': 'Жұмыс аяқталды (күні, уақыты)',
  'table.department': 'БӨЛІМШЕ',
  'table.status': 'МӘРТЕБЕСІ',
  'table.created_by': 'Кім құрған',
  'table.participants': 'Қатысушылар',
  'table.all_branches': 'Барлық филиалдар',
  'table.work_name': 'Жұмыс атауы',
  'table.work_place': 'Жұмыс жүргізілетін жер',
  'table.completion_form': 'Аяқтау тәсілі',
  'table.category': 'Санат',
  'table.task_form': 'Тапсырмалар түрі',
  'table.created_at': 'Құрылған күні',
  'table.updated_at': 'Жаңартылған күні',
  'table.responsible': 'Жауапты',
  'table.executor': 'Орындаушы',
  'table.team_members': 'Бригада мүшелері',
  'table.empty': 'Деректер жоқ',
  'table.actions': 'Әрекеттер',
  'table.view': 'Қарау',
  'table.sign': 'Қол қою',
  'table.cancel_task': 'Нарядтың күшін жою',
  'table.select_branch': 'Филиалды таңдау',
  'table.select_status': 'Мәртебені таңдау',
  'table.search_placeholder': 'Іздеу...',
  'table.contingent': 'Контингент',
  'table.current_status': 'Ағымдағы мәртебесі',
  'common.age': 'Жасы',
  'common.none': 'Жоқ',
  'common.file': 'Файл',
  'table.contacts': 'Байланыс деректері',
  'table.admission_group': 'Рұқсат тобы',
  'table.issuer': 'Наряд, өкім берген тұлға',
  'table.briefed_by': 'Тапсырмамен таныстырды / Нұсқама берді',
  'table.work_producer_or_observer': 'Жұмыс жүргізуші немесе бақылаушы',
  'table.briefed_acknowledged': 'Жұмыс жағдайымен таныстым. Нұсқама алдым',
  'table.team_members_by_order': 'Өкім бойынша жұмыс істейтін бригада мүшелері',
  'table.work_type': 'Жұмыс түрі',
  'table.process': 'Процесс',
  'table.object': 'Объект',
  'table.zone': 'Аймақ',
  'table.conditions': 'Шарттар',
  'table.doc_name': 'Құжат атауы',
  'table.operation': 'Операция',
  'table.process_name': 'Процесс атауы',
  'table.technology_name': 'Технология атауы',
  'table.zone_name': 'Қызмет көрсету аймағының атауы',
  'table.requested_for': 'Кім үшін сұралды',
  'table.issue_text': 'Мәселе мәтіні',
  'table.issue_description': 'Мәселе сипаттамасы',
  'table.slt_time_left': 'Қалған SLT уақыты',
  'table.smax_status': 'SMAX бойынша мәртебесі',
  'table.phone_numbers': 'Телефон нөмірлері',
  'table.line_data': 'Желілік деректер',
  'table.work_time': 'Жұмыс уақыты',
  'table.finished': 'Аяқталды',
  'table.damage_type': 'Зақымдану сипаты',
  'table.reported': 'Мәлімделді',
  'table.discovered': 'Анықталды',
  'table.consumption': 'Шығыс',
  'table.linked_task': 'Байланысты наряд',
  'table.link': 'Сілтеме',
  'table.key': 'Кілт',

  // Feed
  'feed.live_feed': 'Жанды таспа',
  'feed.write_post': 'Жазба жазу',
  'feed.placeholder_write_post': 'Жазба жазу...',
  'feed.edit_post': 'Жазбаны өңдеу',
  'feed.delete_post': 'Жазбаны жою',
  'feed.no_posts': 'Әзірге жазбалар жоқ',

  // Phrases direct mapping
  'Главная': 'Басты бет',
  'Создать Наряд-задание': 'Наряд-тапсырма құру',
  'Создать наряд (старый)': 'Наряд құру (ескі)',
  'Наряд-допуск (электро)': 'Наряд-рұқсат (электр)',
  'Наряд-допуск (не электро)': 'Наряд-рұқсат (электр емес)',
  'Распоряжение': 'Өкім',
  'Работа в порядке текущей эксплуатации': 'Ағымдағы пайдалану тәртібіндегі жұмыс',
  'График ППР': 'ЖЖЖ кестесі',
  'Журнал погоды': 'Ауа райы журналы',
  'Журнал СМАКС': 'СМАКС журналы',
  'Пользователи': 'Пайдаланушылар',
  'Инструкции': 'Нұсқаулықтар',
  'Справочник': 'Анықтамалық',
  'Виды процессов': 'Процесс түрлері',
  'Отчеты': 'Есептер',
  'СОЗДАНА': 'ҚҰРЫЛДЫ',
  'Место и наименование работы': 'Жұмыс орны мен атауы',
  'Указанное время работы': 'Көрсетілген жұмыс уақыты',
  'Дата начало': 'Басталу күні',
  'Дата завершение': 'Аяқталу күні',
  'К работе приступили (дата, время)': 'Жұмысқа кірісті (күні, уақыты)',
  'Работа закончена (дата, время)': 'Жұмыс аяқталды (күні, уақыты)',
  'ПОДРАЗДЕЛЕНИЕ': 'БӨЛІМШЕ',
  'СТАТУС': 'МӘРТЕБЕСІ',
  'Кем создано': 'Кім құрған',
  'Участники': 'Қатысушылар',
  'Фильтр': 'Сүзгі',
  'Нет данных': 'Деректер жоқ',
  'Нет данных.': 'Деректер жоқ',
  'Запостить': 'Жариялау',
  'Отменить': 'Бас тарту',
  'Изменить': 'Өңдеу',
  'Удалить': 'Жою',
  'Сохранить': 'Сақтау',
  'Подписать': 'Қол қою',
  'Просмотр': 'Қарау',
  'Написать пост...': 'Жазба жазу...',
  'Написать комментарий...': 'Пікір жазу...',
  'Прикрепить файл(ы)': 'Файл(дарды) тіркеу',
  'Живая лента': 'Жанды таспа',
  'Создано': 'Құрылды',
  'Выдан': 'Берілді',
  'Получена в работу': 'Жұмысқа қабылданды',
  'В пути': 'Жолда',
  'Приостановлен': 'Тоқтатылды',
  'Завершен без подтверждения ЭЦП': 'ЭЦҚ растауынсыз аяқталды',
  'В работе': 'Жұмыста',
  'Отклонено': 'Қабылданбады',
  'Завершено': 'Аяқталды',
  'Добавить': 'Қосу',
  'Очистить': 'Тазарту',
  'Поиск': 'Іздеу',
  'Действия': 'Әрекеттер',
  'Номер': 'Нөмірі',
  'Номер наряда': 'Наряд нөмірі',
  'ФИО': 'Аты-жөні',
  'Должность': 'Лауазымы',
  'Филиал': 'Филиал',
  'Подразделение': 'Бөлімше',
  'Уведомление': 'Хабарлама',
  'Успешно': 'Сәтті',
  'Ошибка': 'Қате',
  'Предупреждение': 'Ескерту',

  // Auth & System
  'auth.login_title': 'Жүйеге кіру',
  'auth.email_placeholder': 'Email енгізіңіз',
  'auth.password_placeholder': 'Құпиясөзді енгізіңіз',
  'auth.email_required': 'Email енгізіңіз',
  'auth.password_required': 'Құпиясөзді енгізіңіз',
  'auth.sign_in': 'Кіру',
  'auth.invalid_password': 'Құпиясөз қате!',
  'auth.user_not_found': 'Пайдаланушы табылмады!',
  'auth.login_error': 'Авторизация қатесі',

  // Task Draft & Form
  'task.draft_saved': 'Наряд нобайы сақталды',
  'task.draft_restored': 'Наряд нобайы сәтті қалпына келтірілді',
  'task.draft_cleared': 'Нобай тазартылды',
  'task.clear_draft': 'Пішінді тазарту',
  'task.auto_saved': 'Автосақтау қосулы',

  // Modals
  'modal.sign_title': 'Нарядқа қол қою',
  'modal.cancel_title': 'Нарядтан бас тарту',
  'modal.confirm_sign': 'Шынымен қол қойғыңыз келе ме?',
  'modal.confirm_cancel': 'Нарядтан бас тартуға сенімдісіз бе?',
  'modal.enter_reason': 'Себебін көрсетіңіз',
  'modal.reason_required': 'Себебін көрсетуіңізді сұраймыз',

  // Operation Modals
  'operation.sign_order_title': 'Наряд-тапсырмаға қол қою',
  'operation.action_required': 'Әрекет қажет',
  'operation.confirm_sign': 'ЭЦҚ кілті арқылы әрекетті растаңыз',
  'operation.ecp_key_file': 'ЭЦҚ кілт файлы (RSA / GOST / .p12):',
  'operation.change_ecp': 'Басқа кілтті таңдау',
  'operation.upload_ecp': 'ЭЦҚ файлын жүктеу',
  'operation.select_ecp_file': 'ЭЦҚ файлын таңдаңыз',
  'operation.file_read_error': 'ЭЦҚ файлын оқу қатесі',
  'operation.ecp_password': 'ЭЦҚ құпиясөзі:',
  'operation.enter_ecp_password': 'ЭЦҚ сертификатының құпиясөзін енгізіңіз',
  'operation.sign_btn': 'Қол қою',
  'operation.cancel_order_title': 'Наряд-тапсырманы кері қайтару / бас тарту',
  'operation.cancel_warning_title': 'Назар аударыңыз!',
  'operation.cancel_warning_desc': 'Нарядтан бас тарту қайтарылмайтын әрекет. Себебін көрсетіп, ЭЦҚ кілтімен қол қойыңыз.',
  'operation.cancel_reason_label': 'Бас тарту себебі:',
  'operation.cancel_reason_placeholder': 'Бас тарту себебін толық көрсетіңіз...',
  'operation.cancel_reason_required': 'Нарядтан бас тарту себебін жазыңыз!',
  'operation.cancel_success': 'Наряд сәтті кері қайтарылды',
  'operation.reject_btn': 'Нарядтан бас тарту',
  'operation.order_info_title': 'Наряд-тапсырма туралы ақпарат',
  'operation.process': 'Процесс',
  'operation.technology': 'Технология',
  'operation.service_zone': 'Қызмет көрсету аймағы',
  'operation.conditions': 'Шарттар',
  'operation.work_type': 'Жұмыс түрі',
  'operation.entrusted': 'Тапсырылады',
  'operation.completion_form': 'Аяқтау формасы',
  'operation.other_task_name': 'Атауы',
  'operation.visiting_work': 'Көшпелі жұмыс',
  'operation.visiting_work_other': 'Көшпелі жұмыс (басқа)',
  'operation.driver': 'Жүргізуші',
  'operation.photo_confirmation': 'Аяқтауды фототіркеу',
  'operation.photo_attached': 'Нарядқа растайтын фотоматериал тіркелген',
  'operation.view_photo': 'Фотоны көру',
  'operation.sms_confirmation': 'SMS Растау',
  'operation.sms_no_confirm_reason': 'Растаусыз. Себебі:',
  'operation.sms_sent_to': 'SMS жіберілген нөмір:',
  'operation.sms_time': 'Уақыты:',
  'operation.sms_code': 'Код:',
  'operation.status_history': 'Мәртебелердің өзгеру тарихы',
  'operation.status_before': 'Дейінгі мәртебе',
  'operation.status_after': 'Кейінгі мәртебе',
  'operation.datetime': 'Күні мен уақыты',
  'operation.operations_list': 'Операциялар тізімі',
  'operation.operation_name': 'Операция атауы',
  'operation.gps_track_title': 'Қызметкерлердің GPS трегі',
  'operation.select_employees_track': 'Тректі көрсету үшін қызметкерлерді таңдаңыз:',
  'operation.signature_verification_title': 'ЭЦҚ тексеру нәтижелері',
  'operation.download_sig_file': 'Қолтаңба файлын жүктеп алу',
  'operation.signer': 'Қол қоюшы',
  'operation.iin': 'ЖСН:',
  'operation.cert_check': 'Сертификатты тексеру',
  'operation.tsp_check': 'TSP (Уақыт белгісін) тексеру',
  'operation.sig_check': 'Қолтаңбаны тексеру',
  'operation.valid': 'Жарамды (Сәтті)',
  'operation.invalid': 'Сәтсіз',
  'operation.cert_serial': 'Сериялық нөмірі',
  'operation.cert_validity': 'Қолданылу мерзімі',
  'operation.cert_template': 'Сертификат үлгісі',
  'operation.signed_date': 'Қол қойылған күні',
  'operation.comments_modal_title': 'Нарядқа ескертулер мен түсініктемелер',

  // User Profile & Drawer
  'user.profile_title': 'Қызметкер картасы',
  'user.add_title': 'Пайдаланушыны қосу',
  'user.edit_title': 'Пайдаланушыны өңдеу',
  'user.general_info': 'Негізгі ақпарат',
  'user.contacts': 'Байланыс ақпараты',
  'user.safety_and_qualifications': 'Рұқсаттар мен қауіпсіздік',
  'user.email_label': 'Корпоративтік пошта (Email)',
  'user.branch_label': 'Ұйым / Филиал',
  'user.division_label': 'Құрылымдық бөлімше',
  'user.position_label': 'Лауазымы',
  'user.iin_label': 'ЖСН',
  'user.birthdate_label': 'Туған күні',
  'user.started_working_label': 'Жұмысқа қабылданған күні',
  'user.role_label': 'Жүйедегі рөлі',
  'user.status_employee_label': 'Қызметкер мәртебесі',
  'user.active_status_label': 'Тіркелгі мәртебесі',
  'user.phone_work_label': 'Жұмыс телефоны (стационарлық)',
  'user.phone_work_mobile_label': 'Жұмыс ұялы телефоны',
  'user.phone_personal_label': 'Жеке ұялы телефоны',
  'user.electr_group_label': 'Электр қауіпсіздігі бойынша рұқсат тобы',
  'user.electr_admission_date_label': 'Рұқсатты растау күні',
  'user.safety_date_label': 'ЕҚжәнеҚТ емтиханын тапсыру күні',
  'user.medical_passed_label': 'Медициналық тексеру',
  'user.medical_date_label': 'Мед. тексеруден өткен күні',
  'user.is_emerg_repair_staff_label': 'Жедел-жөндеу қызметкерлері',
  'user.admission_height_label': 'Биіктіктегі жұмыстарға рұқсат',
  'user.prof_suitable_label': 'Жұмысқа кәсіби жарамдылығы',
  'user.contingent_label': 'Контингент',
  'user.role_central': 'Орталық аппарат',
  'user.role_admin_system': 'Жүйе әкімшісі',
  'user.role_admin_branch': 'Филиал ӘБҚ',
  'user.role_issuer': 'Наряд беруші',
  'user.role_executor': 'Тапсырмаларды орындаушы',
  'user.group_none': 'Жоқ',
  'user.group_1': 'I топ',
  'user.group_2': 'II топ',
  'user.group_3': 'III топ',
  'user.group_4': 'IV топ',
  'user.group_5': 'V топ',
  'user.fit': 'Жарамды',
  'user.unfit': 'Жарамсыз',
  'user.passed': 'Өтті',
  'user.not_passed': 'Өтпеді',
  'user.copied': 'Алмасу буферіне көшірілді'
};

export default kz;
